module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 133
// module chunks = 26